// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFolderOutlinedSvg from "@fishx/icons-svg/es/asn/PFolderOutlined";
import FishxIcon from '../components/FishxIcon';

var PFolderOutlined = function PFolderOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFolderOutlinedSvg
  }));
};

PFolderOutlined.displayName = 'PFolderOutlined';
export default React.forwardRef(PFolderOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFolderOutlined.js
// module id = 3419
// module chunks = 0